export default function convertPhoneFormat(phone) {
  const cleanedPhone = `${phone}`.replace(/\D/g, '');
  const match = cleanedPhone.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const number = `(${match[2]}) ${match[3]}-${match[4]}`;
    return number;
  }
  return phone;
}
